var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"blockies",staticClass:"d-flex f-auto-center blockies",class:{ 'cursor-pointer': _vm.jump },style:(("border-radius: " + _vm.radius)),on:{"click":_vm.jumpFunc}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0552bd63","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stories/blockies/index.vue
// module id = null
// module chunks = 